

















































































































































































































































import { Component, Vue } from "vue-property-decorator";
    import * as CustomSelectModule from "@/assets/scripts/CustomSelectModule";

@Component
export default class CustomSelect extends Vue {
  data() {
    return {
      PageTitle: "Custom select"
    };
  }
  mounted() {
      new CustomSelectModule.customSelectModule();
  }
}
